import { dateFormat } from '@/utils/utils.js'
let install = Vue => {
  if (install.installed) return
  Vue.mixin({
    filters: {
      dataFormat: function (value, fmt) {
        if (!value) return ''
        value = parseInt(value)
        return dateFormat(new Date(value), fmt)
      },

      // 手机号掩码 182******82
      phoneFormat: function (value) {
        if (value) {
          return (
            value.substring(0, 3) + '*****' + value.substring(value.length - 2)
          )
        }
      },

      // 邮箱掩码
      emailFormat: function (input) {
        var output = input
        if (input === null || input === '' || input === undefined) { return output }
        output = input.trim()
        var emailParts = input.split('@')
        if (emailParts.length > 1) {
          if (emailParts[0].length > 3) {
            output =
              emailParts[0].substr(0, 2) +
              '***' +
              emailParts[0].substr(emailParts[0].length - 1)
          } else if (emailParts[0].length > 0) {
            output = emailParts[0].substr(0, 1) + '***'
          }
          output += '@' + emailParts[1]
        }
        return output
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/filtres/dataFormatFilter.js